import { STATUS } from "../constants/constants";

export const getOrderColor = (status: string): string => {
  let className;
  switch (status) {
    case STATUS.ORDER.ORDER_APPROVED.name:
      className = "bgGreenBtn";
      break;
    case STATUS.ORDER.ORDER_COMPLETED.name:
      className = "bgGreenBtn";
      break;
    case STATUS.ORDER.ORDER_DRAFT.name:
      className = "bgYellowBtn";
      break;
    case STATUS.ORDER.ORDER_CREATED.name:
      className = "bgAquaBtn";
      break;
    case STATUS.ORDER.ORDER_REJECTED.name:
      className = "bgRedBtn";
      break;
    case STATUS.ORDER.ORDER_CANCELLED.name:
      className = "bgRedBtn";
      break;
    case STATUS.ORDER.ORDER_UPDATED.name:
      className = "bgAquaBtn";
      break;
    case STATUS.ORDER.ORDER_PROCESSING.name:
      className = "bgYellowBtn";
      break;
    case STATUS.ORDER.ORDER_DELIVERED.name:
      className = "bgGreenBtn";
      break;
    case STATUS.ORDER.INVOICE_CREATED.name:
      className = "bgAquaBtn";
      break;
    case STATUS.ORDER.THREE_WAY_MATCH_APPROVED.name:
      className = "bgGreenBtn";
      break;
    case STATUS.ORDER.THREE_WAY_MATCH_REJECTED.name:
      className = "bgRedBtn";
      break;
    case STATUS.ORDER.PAYMENT_APPROVED.name:
      className = "bgGreenBtn";
      break;
    case STATUS.ORDER.ORDER_SUBMITTED.name:
      className = "bgPurpleBtn";
      break;
    case STATUS.ORDER.ORDER_INTRANSIT.name:
      className = "bgCyclamen";
      break;
    case STATUS.ORDER.ORDER_DELAYED.name:
      className = "bgAmaranth";
      break;
    case STATUS.ORDER.ORDER_ACCEPTED.name:
      className = "bgViolet";
      break;
    case STATUS.ORDER.PAYMENT_REJECTED.name:
      className = "bgRedBtn";
      break;
    default:
      className = ""; // Default class if status doesn't match any case
  }
  return className;
};

export const getGRNColor = (status: string): string => {
  let className = "";
  switch (status) {
    case STATUS.GRN.GRN_CREATED.id:
      className = "bgAquaBtn";
      break;

    case STATUS.GRN.GRN_DELIVERED.id:
      className = "bgGreenBtn";
      break;

    case STATUS.GRN.GRN_DISPATCHED.id:
      className = "bgPurpleBtn";
      break;

    case STATUS.GRN.GRN_DRAFT.id:
      className = "bgYellowBtn";
      break;

    case STATUS.GRN.GRN_REJECTED.id:
      className = "bgRedBtn";
      break;

    case STATUS.GRN.GRN_PENDING_ACKNOWLEDGEMENT.id:
      className = "bgBrownBtn";
      break;

    default:
      className = "";
  }
  return className;
};
